import React from "react";

import styled from "styled-components/macro";

import RecurringDatePicker from "Payments/Shared/RecurringDatePicker";

import { colors } from "UI/colors";

import { useRecurringGifts } from "../../../RecurringGiftsContext";

export default function GiftDates() {
  const { state, dispatch } = useRecurringGifts();
  const { startDate, endDate } = state.editModal.giftWithEdits;
  const { editPanelValidationError } = state.editModal;

  const setStartDate = (date) => {
    dispatch({
      type: "updateStartDate",
      payload: date,
    });

    if (editPanelValidationError === "startDate") {
      dispatch({ type: "clearEditPanelValidationError" });
    }
  };

  const setEndDate = (date) => {
    dispatch({
      type: "updateEndDate",
      payload: date,
    });
  };

  const startDateIsInPast = new Date(startDate) < new Date();

  return (
    <Wrapper>
      <IconWrapper>
        <Icon className="fa-calendar fad" />
      </IconWrapper>
      <Text>
        <RecurringDatePicker
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          accentColor={colors.fnBlue}
          startDateWord={startDateIsInPast ? "Starting" : "Next payment on"}
        />
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  width: 60px;
  min-width: 60px;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;

const Text = styled.div`
  font-weight: 400;
`;
